/**
 * Nsection B2 Service
 * B.2.適用範圍與生效 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b2';

export interface NsectionB2Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  scope_description: string | null;
  entry_into_force: string | null;
  sectoral_scopes: number[] | null;
  sectoral_scopes_text: string | null;
  nsection_b2_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB2Update {
  scope_description?: string;
  entry_into_force?: string;
  sectoral_scopes?: number[];
  sectoral_scopes_text?: string;
}

const nsectionB2Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB2Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB2Update): Promise<NsectionB2Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB2Service;
